/**
 * NKBA API
 * The RESTful backend behind the NKBA application
 *
 * OpenAPI spec version: V1.0.0
 * Contact: cloud@nkba.org
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { AxiosRequestConfig } from 'axios';
import { axios } from '../axios.config';

import { Product } from '../models/Product';
import { ResultsPartialProductObjectId } from '../models/ResultsPartialProductObjectId';

/* tslint:disable:no-unused-variable member-ordering max-line-length */

export class ProductApiResource {

    /**
     * Create a product
     * 
     * @param body Product data to create
     */
    public createProduct(body?: Partial<Product>, axiosConfig?: AxiosRequestConfig): Promise<Product> {
        const reqPath = '/v1/product';
        let reqConfig = {
            ...axiosConfig,
            method: 'POST',
            url: reqPath,
            data: body
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Return all or a subset of products, paginated
     * 
     * @param from Id to start paginating from
     * @param limit Number of results to return
     * @param ids Comma-separated list of product ids to retrieve
     * @param skus Comma-separated list of product skus to retrieve
     */
    public getAllProducts(query?: { from?: string, limit?: number, ids?: string, skus?: string, type?: string }, axiosConfig?: AxiosRequestConfig): Promise<ResultsPartialProductObjectId> {
        const reqPath = '/v1/product';
        let reqConfig = {
            ...axiosConfig,
            method: 'GET',
            url: reqPath,
            params: query
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Return a particular product by id
     * 
     * @param id Product id
     */
    public getProduct(id: Partial<string>, axiosConfig?: AxiosRequestConfig): Promise<Product> {
        const reqPath = '/v1/product/{id}'
            .replace('{' + 'id}', String(id));
        let reqConfig = {
            ...axiosConfig,
            method: 'GET',
            url: reqPath
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Update an existing product
     * 
     * @param id Product id
     * @param body Product data to update
     */
    public updateProduct(id: Partial<string>, body?: Partial<Product>, axiosConfig?: AxiosRequestConfig): Promise<{}> {
        const reqPath = '/v1/product/{id}'
            .replace('{' + 'id}', String(id));
        let reqConfig = {
            ...axiosConfig,
            method: 'PATCH',
            url: reqPath,
            data: body
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

}

export const ProductApi = new ProductApiResource();



// WEBPACK FOOTER //
// ./src/common/api/resources/ProductApi.ts